import axios from 'axios'

/**
 * Axios validation errors arrive as `{field: [message, ...]}`; callers only
 * ever show the first message per field. A handful of endpoints instead
 * reject with a plain `{message}` (e.g. a declined card, or a "nothing to
 * do" race) — surfaced under a `submission` key so a form's general-error
 * slot picks it up.
 */
export function firstValidationErrors(e: unknown): Record<string, string> | null {
    if (!axios.isAxiosError(e) || e.response?.data == null) {
        return null
    }

    const data = e.response.data as {errors?: Record<string, string[]>, message?: string}

    if (data.errors != null) {
        return Object.fromEntries(Object.entries(data.errors).map(([key, messages]) => [key, messages[0]]))
    }

    if (typeof data.message === 'string') {
        return {submission: data.message}
    }

    return null
}
